import React, {useState} from 'react';
import clinicService from '../../../../../services/clinic.service';
import {useForm} from 'react-hook-form';
import {useParams} from 'react-router-dom';
import {toast} from 'react-toastify'
import Loading from '../../../../common/Loading';


const AddressForm = ({address, updateAddress, updateEditing}) => {
    let {clinicId} = useParams()
    const [isLoading, setIsLoading] = useState(false)

    const {register, handleSubmit, formState: {errors}} = useForm(
        {
            defaultValues: {
                street: address.street,
                city: address.city,
                province: address.province,
                postalCode: address.postalCode,
                country: address.country
            }
        }
    );

    const onSubmit = (data) => {
        setIsLoading(true);

        clinicService.addAddress(clinicId, data)
            .then(res => {
                setIsLoading(false);

                console.log(res);
                // setAddress(res.data);
                updateAddress(res.data)
                toast.success("Address Updated", {
                    position: toast.POSITION.BOTTOM_RIGHT
                })
                updateEditing(false);
            })
            .catch(err => {
                setIsLoading(false);
            });
    }


    return (
        <>
            {isLoading ? <Loading/> : ""}
            <form onSubmit={handleSubmit(onSubmit)} className="needs-validation">
                <div className="row g-3">
                    {/* Street */}
                    <div className="col-12">
                        <label htmlFor="street" className="form-label">Street</label>
                        <input
                            type="text"
                            className={`form-control form-control-sm ${errors?.street ? "is-invalid" : ""}`}
                            id="street"
                            {...register("street", {required: "Street is required"})}
                        />
                        {errors?.street && <div className="invalid-feedback">{errors.street.message}</div>}
                    </div>

                    {/* City */}
                    <div className="col-md-6">
                        <label htmlFor="city" className="form-label">City</label>
                        <input
                            type="text"
                            className={`form-control form-control-sm ${errors?.city ? "is-invalid" : ""}`}
                            id="city"
                            {...register("city", {required: "City is required"})}
                        />
                        {errors?.city && <div className="invalid-feedback">{errors.city.message}</div>}
                    </div>

                    {/* Province */}
                    <div className="col-md-6">
                        <label htmlFor="province" className="form-label">Province/State</label>
                        <input
                            type="text"
                            className={`form-control form-control-sm ${errors?.province ? "is-invalid" : ""}`}
                            id="province"
                            {...register("province", {required: "Province is required"})}
                        />
                        {errors?.province && <div className="invalid-feedback">{errors.province.message}</div>}
                    </div>

                    {/* Postal Code */}
                    <div className="col-md-6">
                        <label htmlFor="postalCode" className="form-label">Postal Code</label>
                        <input
                            type="text"
                            className={`form-control form-control-sm ${errors?.postalCode ? "is-invalid" : ""}`}
                            id="postalCode"
                            {...register("postalCode", {required: "Postal code is required"})}
                        />
                        {errors?.postalCode && <div className="invalid-feedback">{errors.postalCode.message}</div>}
                    </div>

                    {/* Country */}
                    <div className="col-md-6">
                        <label htmlFor="country" className="form-label">Country</label>
                        <input
                            type="text"
                            className={`form-control form-control-sm ${errors?.country ? "is-invalid" : ""}`}
                            id="country"
                            {...register("country", {required: "Country is required"})}
                        />
                        {errors?.country && <div className="invalid-feedback">{errors.country.message}</div>}
                    </div>
                </div>

                <div className="d-flex justify-content-between align-items-center mt-4 pt-2 border-top">
                    <button type="submit" className="btn btn-success btn-sm">
                        <i className="bi bi-floppy me-1"></i> Save
                    </button>
                </div>
            </form>
        </>
    )
}
export default AddressForm;